import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
	ConfirmDialogData,
	ConfirmDialogResult,
	SelectContextDialogData, SelectContextDialogResult,
	SuccessDialogData
} from '../../core/utils/dialog.models';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Context } from "../../../contexts/contexts.model";

@Component({
	selector: 'select-context-dialog',
	templateUrl: './select-context.component.html'
})
export class SelectContextDialogComponent implements OnInit {

	public title: string;
	public text: string;
	public okBtnText: string;
	public cancelBtnText: string;
	public availableContexts: Context[];
	public form: FormGroup;

	public constructor(
		private fb: FormBuilder,
		public dialogRef: MatDialogRef<SelectContextDialogComponent, SelectContextDialogResult>,
		@Inject(MAT_DIALOG_DATA) public data: SelectContextDialogData
	) {}

	public ngOnInit(): void {
		this.title = this.data.title;
		this.text = this.data.text;
		this.okBtnText = this.data.okBtnText;
		this.cancelBtnText = this.data.cancelBtnText;
		this.availableContexts = this.data.availableContexts;
		this.form = this.fb.group({
			contextOriginCode: ['', [Validators.required]],
		});

	}

	public onOkClick(): void {
		this.dialogRef.close(this.form.value);
	}

	public onCancelClick(): void {
		this.dialogRef.close({ contextOriginCode: null });
	}

}
